<div class="scroll-to-top" [ngClass]="[isShown ? 'show' : 'hide']">
    <button type="button" class="btn btn-maroon rounded-circle blue-effect" (click)="scrollToTop()" aria-label="Scroll to top">
        <i class="icon-gard-arrow-up text-white"></i>
    </button>
</div>
